module.exports = __webpack_public_path__ + "img/openai-account-banned-for-policy-violations.6cd53b35.webp";